/* eslint-disable */
export default {
  today: '今日',
  yesterday: '昨日',
  empty: '通話記録なし',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
